var React = require('react');

function StepCircle0860px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm.216-41.796h.036c3.924 0 6.228 2.628 6.228 5.616 0 1.944-.936 4.176-4.14 5.616v.144c3.312 1.296 4.968 3.492 4.968 6.192 0 3.96-3.456 6.624-7.344 6.624-4.176 0-7.308-2.664-7.308-6.228 0-3.024 1.872-5.22 4.896-6.516v-.144c-2.844-1.224-3.96-3.276-3.96-5.292 0-3.528 2.88-6.012 6.624-6.012zm-.288 22.752h.036c3.42 0 5.58-2.088 5.58-4.932 0-3.312-2.232-4.788-6.012-5.868-3.312.972-5.076 3.096-5.076 5.652-.144 2.772 1.944 5.148 5.472 5.148zm.18-21.348h-.036c-3.096 0-4.788 2.016-4.788 4.356-.036 2.808 1.98 4.212 5.148 5.004 2.484-.864 4.284-2.448 4.284-5.004 0-2.124-1.296-4.356-4.608-4.356z"}));
}

StepCircle0860px.displayName = "StepCircle0860px";

StepCircle0860px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0860px;

StepCircle0860px.default = StepCircle0860px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-08-60px.svg
// module id = 1213
// module chunks = 0